// import googleMaps from '../components/google-map';
// import GoogleMapLoader from '../components/google-map-loader';

import storeLocator from "../components/store-locator";

import fontAwesomeIcons from "../components/FontAwesomeIcons";
// import scrollmagicPlugin from "../components/ScrollmagicPlugin";
import OwlCarouselContentCarousel from "../components/OwlCarouselContentCarousel";
import OwlCarouselRangeGallery from "../components/OwlCarouselRangeGallery";

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* if ($('.acf-map').length) {
      new googleMaps;
    } */

    new fontAwesomeIcons;
    /* if ($(".component").length) {
      new scrollmagicPlugin();
    } */
    if ($(".full-width-carousel").length) {
      new OwlCarouselContentCarousel();
    }
    if ($(".range-gallery").length) {
      new OwlCarouselRangeGallery();
    }

    if ($("#store-locator").length) {
      new storeLocator();
    }

    // new GoogleMapLoader;
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js